import { msg } from "@lingui/core/macro";
import { type Component, For, Show } from "solid-js";
import { UserRoundSearch } from "@fleet/icons";
import { useI18n } from "@/providers/i18n-provider";
import { useAccounts } from "@/features/auth/use-accounts";

export const TryAnotherAccount: Component = () => {
  const { t } = useI18n();
  const { accounts, activeUserId, switchHere } = useAccounts();

  const others = () => accounts().filter((account) => account.userId !== activeUserId());

  return (
    <Show when={others().length > 0}>
      <div class="mt-6 flex flex-col items-center gap-2" data-testid="try-another-account">
        <p class="text-xs text-muted-foreground">
          {t(msg`Signed in with more than one account? Try another one:`)}
        </p>
        <div class="flex flex-wrap items-center justify-center gap-2">
          <For each={others()}>
            {(account) => (
              <button
                type="button"
                onClick={() => {
                  void switchHere(account.userId);
                }}
                data-testid={`try-account-${account.userId}`}
                class="flex items-center gap-2 rounded-full border border-border/60 px-3 py-1.5 text-sm font-medium transition-colors hover:bg-accent/10 cursor-pointer"
              >
                <UserRoundSearch class="h-4 w-4 text-muted-foreground" />
                {account.kind === "guest" ? t(msg`Guest`) : account.displayName}
              </button>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
};
